export const CardExpirationDateFieldData = {
  formControlName: 'cardExpirationDate',
  id: 'grit-field-card-expiration-date',
  label: 'Expiration date',
  placeholder: 'MM/YY',
  mask: 'mmyy',
  requiredMessage:
    'Your card expiration date is required to process your initial payment.',
  validationList: [
    {
      errorKey: 'mmYYFuture',
      message: "Your card expiration date must be greater than today's date.",
    },
  ],
};
